/**
 * tdesign v1.11.1
 * (c) 2025 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-8bcc0e9b.js';
import { createContext } from 'react';
import { merge } from 'lodash-es';
import '../locale/zh_CN.js';
import defaultConfig from '../_common/js/global-config/default-config.js';
import zhCN from '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-6b7c7d34.js';
import '../_chunks/dep-248ede8a.js';
import '../_chunks/dep-35c2a089.js';
import '../_chunks/dep-fad4e87b.js';
import 'dayjs';
import '../_chunks/dep-81c9c3a2.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EAnimationType = /* @__PURE__ */function (EAnimationType2) {
  EAnimationType2["ripple"] = "ripple";
  EAnimationType2["expand"] = "expand";
  EAnimationType2["fade"] = "fade";
  return EAnimationType2;
}(EAnimationType || {});
var defaultClassPrefix = "t";
var defaultAnimation = {
  include: ["ripple" /* ripple */, "expand" /* expand */, "fade" /* fade */],
  exclude: []
};
var defaultGlobalConfig = _objectSpread({
  animation: defaultAnimation,
  classPrefix: defaultClassPrefix
}, merge({}, zhCN, defaultConfig));
var defaultContext = {
  globalConfig: defaultGlobalConfig
};
var ConfigContext = /*#__PURE__*/createContext(defaultContext);

export { EAnimationType, ConfigContext as default, defaultAnimation, defaultClassPrefix, defaultContext, defaultGlobalConfig };
//# sourceMappingURL=ConfigContext.js.map
